"use client"

import { PulseLoader } from "react-spinners"
import FadeLoader from "react-spinners/FadeLoader"

import styles from "./spinner.module.scss"

const PartialSpinner = () => (
  <div className={styles.partialSpinner}>
    <PulseLoader color="#00c9ff" />
  </div>
)

const Spinner = ({ isOpen = true }: { isOpen?: boolean }) =>
  isOpen && (
    <div className={styles.backdrop}>
      <div className={styles.center}>
        <FadeLoader height={25} width={8} margin={21} radius={10} />
      </div>
    </div>
  )

export default Spinner
export { PartialSpinner }
